import type { ButtonProps } from './components/buttons/declare'
import * as List from './components/buttons/list'
import * as Edit from './components/buttons/edit'
import * as EditTree from './components/buttons/edittree'
import * as Tree from './components/buttons/tree'
import { $consts } from 'src/plugins'
import { useBtnPermission } from './helper'

const LoadableButton = (props: ButtonProps) => {
  const isValidBtn = useBtnPermission(props.config.ID)
  if (!isValidBtn) return <div />

  // 列表表单配置按钮
  if (props.pageType === $consts['TABLE/FORM_TYPE_LIST_PAGE']) {
    switch (props.locateBtn) {
      // 列表表单表格头部按钮
      case $consts['TABLE/BTN_LOCATE_HEADER']:
        return <List.HeaderButton config={props.config} />
      // 列表表单表格行按钮
      case $consts['TABLE/BTN_LOCATE_ROW']:
        return <List.RowButton config={props.config} />
      default:
        return <div />
    }
  }
  // 编辑表单配置按钮
  if (props.pageType === $consts['TABLE/FORM_TYPE_EDIT_PAGE']) {
    switch (props.locateBtn) {
      // 编辑表单表单配置按钮
      case $consts['TABLE/BTN_LOCATE_PAGER']:
        return <Edit.PagerButton config={props.config} />
      // 编辑表单子表表头配置按钮
      case $consts['TABLE/BTN_LOCATE_HEADER']:
        return <Edit.HeaderButton config={props.config} />
      // 编辑表单子表列表行配置按钮
      case $consts['TABLE/BTN_LOCATE_ROW']:
        return <Edit.RowButton config={props.config} />
      default:
        return <div />
    }
  }
  // 编辑树表单配置按钮
  if (props.pageType === $consts['TABLE/FORM_TYPE_EDITTREE_PAGE']) {
    switch (props.locateBtn) {
      // 编辑树表单弹框类型按钮
      case $consts['TABLE/BTN_LOCATE_HEADER']:
        return <EditTree.HeaderButton config={props.config} />
      default:
        return <div />
    }
  }
  // 竖树表单配置按钮
  if (props.pageType === $consts['TABLE/FORM_TYPE_TREE_PAGE']) {
    switch (props.locateBtn) {
      // 竖树表单页面类型按钮
      case $consts['TABLE/BTN_LOCATE_PAGER']:
        return <Tree.PagerButton config={props.config} />
      // 竖树表单弹框类型按钮
      case $consts['TABLE/BTN_LOCATE_HEADER']:
        return <Tree.HeaderButton config={props.config} />
      // 层级树侧边配置按钮
      case $consts['TABLE/BTN_LOCATE_SIDER']:
        return <Tree.SiderButton config={props.config} />
      default:
        return <div />
    }
  }
  return <div />
}

export default LoadableButton